// src/services/axios.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const API_URL = `${BASE_URL}`; 

const instance = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token automatically if available
instance.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export default instance;
